(function() {
    var ui = fpUtil.getNamespace('ui', fp);

    ui.Pager = fp.Component.extend({
        construct: function (element, config, template, parent) {
            template = template || $(element).attr('data-template') || 'component/1/pager.html';

            this._super(element, config, template, parent);

            _.defaults(config, {
                limit: fpConstants.pager.ITEMS_PER_PAGE,
                defaultMaxSize: fpConstants.pager.MAX_SIZE
            });

            var responsiveMaxSize = fpConfig.pagerResponsiveMaxSize || [[0, 4], [fpConstants.matchMediaMin.SM]],
                responsiveMaxSizeFirstLast = fpConfig.pagerResponsiveMaxSize || [[0, 2], [fpConstants.matchMediaMin.SM]];

            if(template == 'component/1/pager.html') _.defaults(config, {responsiveMaxSize: responsiveMaxSize, responsiveBaseWidth: window});
            if(template == 'component/2/pager.html') _.defaults(config, {responsiveMaxSize: responsiveMaxSizeFirstLast, responsiveBaseWidth: window});

            if(_.isArray(config.responsiveMaxSize)) fpUtil.sort(config.responsiveMaxSize);
        },
        render: function(params) {
            var scope = this.scope,
                stateManager = scope.stateManager,
                stateParams = stateManager.stateParams;

            params = _.defaults(params, {
                limit: stateParams.limit || scope.limit,
                totalItems: scope.totalItems,
                simple_paging: false,
                itemsLength: 1
            });

            var $element = this.$element,
                config = this.config,
                responsiveMaxSize = config.responsiveMaxSize,
                maxSize = config.defaultMaxSize,
                page = fpUtil.getInteger(stateParams.page, 1),
                limit = fpUtil.getInteger(params.limit, config.limit),
                isResponsive = _.size(responsiveMaxSize);

            scope.totalItems = fpUtil.isInteger(params.totalItems) ? params.totalItems : fpUtil.getInteger(config.totalItems);
            scope.limit = limit;
            scope.simple_paging = params.simple_paging && scope.totalItems <= 0;
            scope.itemsLength = params.itemsLength;
            scope.backLink = params.backLink;

            if(limit > 0) {
                if(isResponsive) {
                    var width = config.responsiveBaseWidth.innerWidth,
                        item;

                    for (var n = 0; n < responsiveMaxSize.length; n++) {
                        item = responsiveMaxSize[n];
                        if (item[0] <= width) maxSize = fpUtil.getInteger(item[1], config.defaultMaxSize);
                    }
                }
                
                
                if(scope.simple_paging){
                    scope.currentPage = stateParams.page || 1;
                    scope.maxPage = scope.currentPage + 1;
                }else{
                    scope.currentPage = ui.Pager.getPage(page, scope.totalItems, limit) || 1;
                    scope.maxPage = Math.ceil(scope.totalItems / limit);
                    scope.startPage = scope.currentPage - Math.floor(maxSize * 0.5);

                    if (scope.startPage < 1) scope.startPage = 1;

                    scope.endPage = scope.startPage + maxSize - 1;
                    if (scope.endPage > scope.maxPage) {
                        scope.endPage = scope.maxPage;
                        scope.startPage = scope.endPage - maxSize + 1;
                        if (scope.startPage < 1) scope.startPage = 1;
                    }

                    scope.startItem = (scope.currentPage - 1) * limit + 1;
                    var endItem = (scope.startItem - 1) + limit;
                    scope.endItem = endItem < scope.totalItems ? endItem : scope.totalItems;
                }
            }
            else {
                scope.totalItems = 0;
                scope.currentPage = scope.maxPage = scope.startPage = scope.endPage = scope.startItem = scope.endItem = 1;
            }

            this._super(params);

            if(config.enablePageLimit) {
                $element.find('[data-role="dropdown-page-limit"]').dropdown2({
                    //align: 'right',
                    items: config.items || [
                        {id: '25', name: 'Show: 25'},
                        {id: '50', name: 'Show: 50'},
                        {id: '100', name: 'Show: 100'}
                    ],
                    value: scope.limit,
                    selectConfig: {
                        dropdownAutoWidth: true
                    },
                    onChange: function(value) {
                        stateManager.go(stateManager.current, {limit: value}, {inherit: true});
                    }
                });
            }

            if(scope.backLink){
                $element.find('.fp-back-link').html(scope.backLink);
            }

            $element
                .toggleClass('hidden', fpUtil.getBoolean(!this.rendered || (!scope.simple_paging && (!config.enablePageLimit && scope.maxPage <= 1) || (config.enablePageLimit && !scope.maxPage))))
                .find('.fp-btn-next, .fp-btn-last')
                    .toggleClass('fp-disabled', scope.currentPage == scope.maxPage || scope.itemsLength <= 0)
                .end()
                .find('.fp-btn-prev, .fp-btn-first')
                    .toggleClass('fp-disabled', scope.currentPage == 1);

            $element
                .on('click', '.fp-paging a', function(event) {
                    event.preventDefault();

                    var $target = $(event.target),
                        page = fpUtil.getInteger(stateParams.page, 1),
                        total = scope.totalItems || 0;
                        
                    switch($target.attr('data-role')) {
                        case 'first':
                            if(scope.simple_paging) page = 1;
                            else page = 'first';
                            break;
                        case 'last':
                            page = 'last';
                            break;
                        case 'prev':
                            if(page != 1) page--;
                            else return;
                            break;
                        case 'next':
                            page++;
                            break;
                        default:
                            page = fpUtil.getInteger($target.text(), 1);
                            break;
                    }

                    if(!scope.simple_paging) page = ui.Pager.getPage(page, total, scope.limit);

                    if(scope.currentPage == page) return;

                    stateManager.go(stateManager.current, {page: page}, {inherit: true});
                });

            this.__attachScopeEvents();
        },
        __attachScopeEvents: function() {
            this._super();

            var self = this,
                $scope = $(this.scope);

            //if(!(fpConfig.disableSmartScrollResults && !fp.device.xs)) {
            //    $scope
            //        .on(fp.events.ROUTE_CHANGED, function (event, payload) {
            //            if(event.handled) return;
            //            event.handled = true;
            //
            //            if (payload.clientParams.scrollTo) return;
            //            if (payload.fromState != payload.toState) return;
            //            if(!_.has(payload.changedParams, 'page')) return;
            //
            //            _.defer(function () {
            //                if (payload.clientParams.scrollTo) return;
            //
            //                fpUtil.scrollTo();
            //            });
            //        });
            //}

            if(_.size(this.config.responsiveMaxSize)) {
                $scope
                    .on(fp.events.MEDIA_WIDTH_CHANGE, function (event, payload) {
                        self.render();
                    });
            }
        }
    });

    ui.Pager.getPage = function(value, total, limit) {
        if(value == 'first') return 1;

        total = total || 0;
        limit = limit || fpConstants.pager.ITEMS_PER_PAGE;

        var stateManager = ui.router.stateManager,
            stateParams = stateManager.stateParams,
            maxPage = Math.ceil(total / limit);

        if(value == 'last') return maxPage;

        var page = fpUtil.getInteger(value) || (stateParams.page != null ? 1 : null);

        if(page) {
            if(page < 1) page = 1;
            else {
                if(!total) page = 1;
                else if(page * limit > total) page = maxPage;
            }
        }
        return page;
    };

    ui.Pager.ensurePage = function(page, total, limit) {
        var stateManager = ui.router.stateManager,
            stateParams = stateManager.stateParams;
        if(page == 1 && fpUtil.isNull(stateParams.page)) return true;

        var correctPage = this.getPage(page, total, limit) || 1;
        // fp.log(correctPage, page, total, limit);
        if(correctPage != page) {
            stateManager.go(stateManager.current, {page: correctPage}, {inherit: true});
            return false;
        }
        return true;
    };

})();